import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  FlexBox, GradientContainer, Logo,
} from '../../components';
import { Title, Description, ErrorMessage } from '../../components/typography';
import { Button } from '../../components/buttons';
import * as LicenseAPI from '../../api/Licenses';
import { useUserStore } from '../../hooks/zustand/user';

function CheckoutSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const authCheck = useUserStore((state) => state.authCheck);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');

    if (!sessionId) {
      setError('Missing session ID');
      setLoading(false);
      return;
    }

    const verifySession = async () => {
      try {
        const response = await LicenseAPI.verifyCheckoutSession(sessionId);
        if (response.data.data.success) {
          setSuccess(true);
          // Refresh user data to get updated license status
          await authCheck();
          // Redirect to gallery after a brief delay
          setTimeout(() => {
            navigate('/gallery');
          }, 2000);
        } else {
          setError('Failed to verify checkout session');
        }
      } catch (err: any) {
        setError(err.response?.data?.error || 'Failed to verify checkout. Please contact support.');
      } finally {
        setLoading(false);
      }
    };

    verifySession();
  }, [searchParams, navigate, authCheck]);

  return (
    <GradientContainer>
      <FlexBox alignItems="center">
        <Logo />

        <FlexBox textAlign="center" marginY={5}>
          {loading && (
            <>
              <Title>Processing your subscription...</Title>
              <Description>Please wait while we verify your payment.</Description>
            </>
          )}

          {success && (
            <>
              <Title>Welcome to Pressto!</Title>
              <Description>
                Your subscription is active. Redirecting you to your gallery...
              </Description>
            </>
          )}

          {error && (
            <>
              <Title>Verification Failed</Title>
              <ErrorMessage style={{ marginTop: '1rem' }}>
                {error}
              </ErrorMessage>
              <Button
                onClick={() => navigate('/gallery')}
                label="Go to Gallery"
                style={{ marginTop: '1rem' }}
              />
            </>
          )}
        </FlexBox>
      </FlexBox>
    </GradientContainer>
  );
}

export default CheckoutSuccess;

